import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY_DATA } from "../../constant/CompanyData";
import Eyebrow from "../common/Eyebrow";

const TermsOfUse = () => {
  return (
    <div className="bg-slate-50 py-16 px-6 sm:px-12 md:px-24">
      <Helmet>
        <title>Terms of Use - QuantaRock</title>
        <meta
          name="description"
          content="Terms of Use for QuantaRock Systems Pvt Ltd's website and services."
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://quantarock.in/legal/terms" />
      </Helmet>

      <div className="mx-auto max-w-4xl">
        <div className="text-center">
          <Eyebrow>Legal</Eyebrow>
        </div>
        <h1 className="mt-3 text-center text-4xl font-bold tracking-tight text-[var(--website-primary-color)]">
          Terms of Use
        </h1>

        <div className="mt-10 space-y-8 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm md:p-12">
          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              1. Introduction
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              Welcome to QuantaRock Systems Pvt Ltd. By accessing or using our
              website, you agree to comply with the following terms and
              conditions. These terms govern your use of the website and our
              services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              2. About QuantaRock Systems Pvt Ltd
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              QuantaRock Systems Pvt Ltd is a technology-oriented company
              specializing in providing innovative software solutions and a
              broad spectrum of IT services, including data center hosting,
              colocation, rental server solutions, and cloud computing.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              3. Acceptable Use
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              You agree not to use our website or services for any unlawful
              purpose, to transmit malicious code, to attempt unauthorized
              access to our systems or those of other users, or to interfere
              with the normal operation of our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              4. Intellectual Property
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              All content on this website, including text, graphics, logos,
              and software, is the property of QuantaRock Systems Pvt Ltd or
              its licensors and is protected by applicable intellectual
              property laws. You may not reproduce, distribute, or create
              derivative works without our prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              5. Service Availability
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              Specific service levels, uptime commitments, and support terms
              for colocation, hosting, and other paid services are governed
              by the individual service agreement or order form signed with
              the client, which takes precedence over this general Terms of
              Use for that service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              6. Limitation of Liability
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              To the maximum extent permitted by law, QuantaRock Systems Pvt
              Ltd shall not be liable for any indirect, incidental, or
              consequential damages arising from your use of, or inability to
              use, our website or services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              7. Governing Law
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              These Terms of Use are governed by the laws of India, and any
              disputes arising from them shall be subject to the exclusive
              jurisdiction of the courts of Indore, Madhya Pradesh.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              8. Modifications to the Terms
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              We may update these Terms of Use at any time. Please review
              these terms regularly to stay informed about any changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[var(--website-primary-color)]">
              9. Contact Us
            </h2>
            <p className="mt-2 leading-relaxed text-slate-600">
              Questions about these terms can be directed to{" "}
              <a
                href={`mailto:${COMPANY_DATA.mailID}`}
                className="font-semibold text-[var(--website-secondary-color)]"
              >
                {COMPANY_DATA.mailID}
              </a>
              .
            </p>
          </section>
        </div>

        <p className="mt-8 text-center text-sm text-slate-500">
          Copyright &copy; {new Date().getFullYear()} — All rights reserved
          by {COMPANY_DATA.companyName}
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
